function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0ED198",
  fillRule: "evenodd",
  d: "M18.502 8.623l-7.87 7.926a.975.975 0 0 1-.613.223c-.056 0-.112 0-.168-.028a.968.968 0 0 1-.53-.335l-3.823-3.823c-.307-.335-.307-.865.028-1.172a.826.826 0 0 1 1.144 0l3.349 3.349L17.33 7.45c.335-.307.865-.307 1.172.028a.825.825 0 0 1 0 1.144M12 0C5.386 0 0 5.386 0 12s5.386 12 12 12 12-5.386 12-12c0-6.642-5.386-12-12-12"
});

const SvgIcSuccess = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-success.509d0ca8.svg";
export { ForwardRef as ReactComponent };